import React from 'react';
import logo from '../../resources/images/Screenshot 2023-03-02 012339.png';
import './Header.css';

const Header = () => {
    return (
        <div className='header'>
            <img src={logo} alt="logo" />
            <nav>
                <a href="/shop">Shop</a>
                <a href="/review">Order Review</a>
                <a href="/manage">Manage Inventory</a>
            </nav>
        </div>
    );
};

export default Header;